/* Créée par Incipit Studio — règles portables, sans identifiants Shopify. */
(function (root) {
  'use strict';
  const keys = ['vehicle', 'interior', 'mileage', 'passengers', 'scent', 'use'];
  const allowed = {
    interior: ['fabric', 'leather', 'alcantara', 'velvet', 'leather_fabric', 'alcantara_leather'],
    mileage: ['low', 'medium', 'high'], passengers: ['solo', 'rear', 'family', 'clients'],
    scent: ['gourmand', 'woody', 'fruity', 'powdery', 'variety'], use: ['occasional', 'continuous', 'both']
  };
  function clean(input) {
    const answers = {};
    if (!input || typeof input !== 'object') return answers;
    if (typeof input.vehicle === 'string') answers.vehicle = input.vehicle.replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 100);
    for (const key of keys.slice(1)) if (allowed[key].includes(input[key])) answers[key] = input[key];
    return answers;
  }
  function recommend(input) {
    const a = clean(input);
    if (!keys.every(key => a[key])) return null;
    const high = a.mileage === 'high';
    const two = (a.passengers === 'clients' && a.mileage !== 'low') || (a.passengers === 'rear' && high);
    let formats;
    if (a.use === 'occasional') formats = [high ? 'spray_500' : 'spray_150'];
    else if (a.use === 'continuous') formats = two ? [high ? 'spray_500' : 'spray_150', 'diffuser_160', 'hanging'] : [high ? 'spray_500' : 'spray_150', a.passengers === 'solo' && a.mileage === 'low' ? 'hanging' : 'diffuser_160'];
    else if (!high) formats = two ? ['duo', 'diffuser_160'] : ['duo'];
    else formats = two ? ['spray_500', 'diffuser_160', 'hanging'] : ['spray_500', 'diffuser_160'];
    const scent = ({gourmand:'krumble', woody:'sweet', fruity:'candy', powdery:'velvet'})[a.scent] || 'krumble';
    return { version: 4, scent, scents: a.scent === 'variety' ? ['krumble','velvet'] : [scent], varied: a.scent === 'variety',
      needsScentChoice: false, formats, reasons: {mileage:a.mileage, passengers:a.passengers, use:a.use} };
  }
  const fallbackScents = Object.freeze({krumble:['krumble','velvet','sweet','candy'],velvet:['velvet','krumble','sweet','candy'],sweet:['sweet','krumble','velvet','candy'],candy:['candy','krumble','sweet','velvet']});
  root.KaarzQuizRules = Object.freeze({version:4, fallbackScents, storageKey:'kaarz.quiz.v1', keys, allowed, clean, recommend});
})(typeof window !== 'undefined' ? window : globalThis);
